import { ToothPeriodontal } from '../../../../graphql/graphql';
import parseSimplePeriodontalValue from './parseSimplePeriodontalValue';
import parsePeriodontalItemValues from './parsePeriodontalItemValues';

export default function getHistoryValuePeriodontal(
	periodontal: ToothPeriodontal,
) {
	const resultArray: string[] = [];
	const { mobility, furcation, ...periodontalItems } = periodontal;

	if (mobility) {
		resultArray.push(parseSimplePeriodontalValue('mobility', mobility));
	}

	if (furcation) {
		resultArray.push(parseSimplePeriodontalValue('furcation', furcation));
	}

	Object.entries(periodontalItems).forEach(([key, value]) =>
		resultArray.push(parsePeriodontalItemValues(key, value)),
	);

	return resultArray.join(', ');
}
